module.exports = __webpack_public_path__ + "img/78563996755380a0151f432af890c43a.png";